import { api } from '../api';
import type {
  CustomerReservationDetails,
  GuestCustomerReservationDetails,
  ReservationsResponse,
} from './reservations.types';

export interface ReservationsProps {
  enabled?: boolean;
  includeReviewableProducts?: boolean;
  jwt: string | null;
  storeId?: string | number;
}

export interface ReservationDetailsProps {
  id: string | number;
  jwt: string | null;
}

export interface GuestReservationDetailsProps {
  id: string | number;
}

interface ReservationDetailsResponse {
  reservation: CustomerReservationDetails;
}

interface GuestReservationDetailsResponse {
  guest_reservation?: GuestCustomerReservationDetails;
  /** @deprecated remove at next opportunity */
  guestReservation: GuestCustomerReservationDetails;
}

const BASE_RESERVATIONS_URL = '/v1/users/reservations';

export const reservationsUrls = {
  reservations: ({
    includeReviewableProducts,
  }: Pick<ReservationsProps, 'includeReviewableProducts'> = {}) =>
    includeReviewableProducts
      ? '/v1/users/reservation_history?include_reviewable_products=true'
      : '/v1/users/reservation_history',
  reservationsByStore: ({ storeId }: Pick<ReservationsProps, 'storeId'>) =>
    `/v1/users/store_reservation_history?store_id=${storeId}`,
  reservationDetails: ({ id }: Pick<ReservationDetailsProps, 'id'>) =>
    `${BASE_RESERVATIONS_URL}/${id}/details`,
  guestReservationDetails: ({ id }: GuestReservationDetailsProps) =>
    `${BASE_RESERVATIONS_URL}/${id}/guest_details`,
  // reviewReservation: ({ id }: ReservationRequestProps) =>
  //   `${BASE_RESERVATIONS_URL}/${id}/reviews`,
  // cancelReservation: ({ id }: ReservationRequestProps) =>
  //   `${BASE_RESERVATIONS_URL}/${id}`,
  // cancelGuestReservation: () => '/guest_carts',
  // notifyCurbsideArrival: ({ id }: ReservationRequestProps) =>
  //   `${BASE_RESERVATIONS_URL}/${id}/curbside_customer_arrived`,
  // reservationOwnerships: ({ id }: ReservationRequestProps) =>
  //   `${BASE_RESERVATIONS_URL}/${id}/ownerships`,
};

export const fetchReservationDetails = async ({
  id,
  jwt,
}: ReservationDetailsProps) => {
  const url = reservationsUrls.reservationDetails({ id });

  const response = await api.get<ReservationDetailsResponse>(url, jwt);

  return response.reservation;
};

export const fetchGuestReservationDetails = async ({
  id,
}: GuestReservationDetailsProps): Promise<GuestCustomerReservationDetails> => {
  const url = reservationsUrls.guestReservationDetails({ id });

  const response = await api.get<GuestReservationDetailsResponse>(url);
  return response.guest_reservation || response.guestReservation;
};

export const fetchReservations = async ({
  includeReviewableProducts,
  jwt,
  storeId,
}: ReservationsProps) => {
  const url = storeId
    ? reservationsUrls.reservationsByStore({ storeId })
    : reservationsUrls.reservations({ includeReviewableProducts });

  const response = await api.get<ReservationsResponse>(url, jwt);

  return response.reservations || [];
};
